<template>
  <main id="create-operator-page" class="page-container">
    <!-- Messaggi di errore e successo -->
    <!-- <p
      v-if="errorMessage"
      :class="{ 'error-message': true, show: errorMessage }"
    >
      {{ errorMessage }}
    </p>
    <p
      v-if="successMessage"
      :class="{ 'success-message': true, show: successMessage }"
    >
      {{ successMessage }}
    </p> -->

    <form class="operator-form" @submit.prevent="onCreateOperator">
      <!-- ===================== RIGA 1 ===================== -->
      <div class="create-operator-row row-1">
        <!-- Nome Operatore -->
        <div class="field">
          <label for="operator-name">Nome operatore *</label>
          <input
            id="operator-name"
            type="text"
            v-model="formData.operatorName"
            placeholder="inserisci"
            required
          />
          <!-- lasciamo required per vedere la modifica quando facciamo aggiornamento -->
        </div>

        <div class="radio-fields-container">
          <!-- Radio Dipendente -->
          <div class="field">
            <label for="employee">Dipendente *</label>
            <input
              type="radio"
              id="employee"
              name="role"
              value="employee"
              v-model="formData.role"
              required
            />
          </div>

          <!-- Radio Collaboratore -->
          <div class="field">
            <label for="collaborator">Collaboratore *</label>
            <input
              type="radio"
              id="collaborator"
              name="role"
              value="collaborator"
              v-model="formData.role"
              required
            />
          </div>
        </div>
      </div>

      <hr />

      <!-- ===================== RIGA 2 ===================== -->
      <div class="create-operator-row row-2">
        <!-- Ragione Sociale -->
        <div class="field">
          <label for="business-name">Ragione sociale</label>
          <input
            id="business-name"
            type="text"
            v-model="formData.companyName"
            placeholder="inserisci"
          />
        </div>

        <!-- Email -->
        <div class="field">
          <label for="email">Email *</label>
          <input
            id="email"
            type="email"
            v-model="formData.email"
            placeholder="inserisci"
            required
          />
        </div>

        <!-- Partita IVA -->
        <div class="field">
          <label for="vat-number">P.IVA</label>
          <input
            id="vat-number"
            type="text"
            v-model="formData.vatNumber"
            placeholder="inserisci"
          />
        </div>

        <!-- PEC -->
        <div class="field">
          <label for="pec">Pec</label>
          <input
            id="pec"
            type="email"
            v-model="formData.pec"
            placeholder="inserisci"
          />
        </div>

        <!-- Codice Univoco -->
        <div class="field">
          <label for="unique-code">Codice univoco</label>
          <input
            id="unique-code"
            type="text"
            v-model="formData.uniqueCode"
            placeholder="inserisci"
          />
        </div>

        <!-- Sede Legale -->
        <div class="field">
          <label for="legal-address">Sede legale</label>
          <input
            id="legal-address"
            type="text"
            v-model="formData.legalHeadquarters"
            placeholder="inserisci"
          />
        </div>

        <!-- Bottone Salva, allineato a destra -->
        <div class="save-button-container">
          <button id="create-operator-button" type="submit">Salva</button>
        </div>
      </div>

      <!-- <hr /> -->

      <!-- ===================== RIGA 3 ===================== -->
      <!-- <div class="create-operator-row row-3">
        <div class="field">
          <label for="image">Immagine</label>
          <input
            id="image"
            type="file"
            @change="handleImageUpload"
            accept="image/*"
          />
        </div>
      </div> -->
    </form>
  </main>
</template>

<script>
import { mapActions } from "vuex/dist/vuex.cjs.js";
import { useToast } from "vue-toast-notification";

export default {
  setup() {
    const toast = useToast();
    return {
      toast,
    };
  },
  name: "CreateOperatorPage",
  data() {
    return {
      formData: {
        operatorName: "",
        role: "",
        companyName: "",
        email: "",
        vatNumber: "",
        pec: "",
        uniqueCode: "",
        legalHeadquarters: "",
        // image: null,
      },
      // errorMessage: "",
      // successMessage: "",
    };
  },
  methods: {
    // Mappa l'azione createOperator dallo store
    ...mapActions(["createOperator"]),

    // handleImageUpload(e) {
    //   const file = e.target.files[0];
    //   if (file) {
    //     this.formData.image = file;
    //   }
    // },
    async onCreateOperator() {
      try {
        // this.errorMessage = "";
        // this.successMessage = "";

        const payload = { ...this.formData };

        const response = await this.$store.dispatch("createOperator", payload);
        if (response.status === 200 || response.status === 201) {
          // this.$nextTick(() => {
          // this.successMessage =
          this.toast.success(
            response.data?.message || "Operatore creato con successo!"
          );
          // });
          // Reset campi
          this.formData = {
            operatorName: "",
            role: "",
            companyName: "",
            email: "",
            vatNumber: "",
            pec: "",
            uniqueCode: "",
            legalHeadquarters: "",
            // image: null,
          };

          // alternativa per resettare i campi
          // Object.keys(this.formData).forEach(
          //   (k) => (this.formData[k] = "")
          // );

          // redirect alla pagina operators
          setTimeout(() => {
            this.$router.push({ name: "operators" });
          }, 1000);
        }
      } catch (error) {
        // Se arrivi qui, c’è un errore => error.response esiste
        if (error.response?.status === 409) {
          // Gestisci il conflitto
          // this.$nextTick(() => {
          // this.errorMessage =
          this.toast.error(
            error.response.data?.details ||
              "Conflitto nei dati, chiave univoca 'Email' già presente."
          );
          // });
        } else {
          // this.$nextTick(() => {
          // this.errorMessage =
          this.toast.error(
            error.response?.data?.details ||
              error.response?.data?.error ||
              "Errore durante l'aggiunta dell'articolo."
          );
          // });
        }
        // this.successMessage = "";
      }
    },
  },
};
</script>

<style src="@/css/CreateOperatorPage.css"></style>
